var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.67 25.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffde00;}.cls-2{fill:#3c2321;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x3C_\\uB808\\uC774\\uC5B4_x3E_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.67,12.84c0,7.09-5.75,12.84-12.83,12.84S0,19.92,0,12.84,5.75,0,12.83,0s12.83,5.75,12.83,12.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.84,6.19c-3.84,0-6.94,2.88-6.94,6.42,0,2.62,1.1,3.87,2.6,5.01h0v3.08c0,.14.16.23.28.14l2.63-1.96.06.02c.44.08.9.12,1.37.12,3.83,0,6.94-2.88,6.94-6.42s-3.11-6.42-6.94-6.42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.f4107da3d0c2163615bf7880ab604def.svg";
export { ForwardRef as ReactComponent };